import { render, staticRenderFns } from "./actBannerCom.vue?vue&type=template&id=aeb81c88&scoped=true"
import script from "./actBannerCom.vue?vue&type=script&lang=js"
export * from "./actBannerCom.vue?vue&type=script&lang=js"
import style0 from "./actBannerCom.vue?vue&type=style&index=0&id=aeb81c88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb81c88",
  null
  
)

export default component.exports